import { cs } from "@repo/ui";
import Attention from "../../../components/AttentionBlock";
import { Seo } from "../../../components/SEO";
import { BodyTextM } from "../../../components/Typography";
import withProtection from "../../../highOrderComponents/withProtection";


export const Title = (): string => cs.profile.communicationContractation.header;

const Info = (): JSX.Element => {
	return (
		<>
			<BodyTextM>{cs.profile.communicationContractation.content}</BodyTextM>
			<Attention severity="info" title={cs.profile.communicationContractation.blue.title}>
				<span
					dangerouslySetInnerHTML={{ __html: cs.profile.communicationContractation.blue.content }}
				></span>
			</Attention>
		</>
	);
};


export const Head = (): JSX.Element => (
	<Seo title={Title()}>
		<meta name="robots" content="noindex" />
	</Seo>
);

export default withProtection(Info);
